/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  MarkAllNotificationsReadBodyDto,
  NotificationsControllerGetNotifications200,
  NotificationsControllerGetNotificationsParams,
  NotificationsControllerGetSubscriptionInfo200,
  NotificationsControllerGetUnreadCount200,
  NotificationsControllerMarkAllAsRead200,
  NotificationsControllerMarkAsRead200,
  PushSubscriptionDto,
  PushUnsubscribeDto,
} from "../client.schemas";

import { api } from "../../lib/orval-mutator";
import type { ErrorType, BodyType } from "../../lib/orval-mutator";

/**
 * 사용자의 알람 목록을 조회합니다.
 * @summary 알람 목록 조회
 */
export const notificationsControllerGetNotifications = (
  params?: NotificationsControllerGetNotificationsParams,
  signal?: AbortSignal,
) => {
  return api<NotificationsControllerGetNotifications200>({
    url: `/notifications`,
    method: "GET",
    params,
    signal,
  });
};

export const getNotificationsControllerGetNotificationsQueryKey = (
  params?: NotificationsControllerGetNotificationsParams,
) => {
  return [`/notifications`, ...(params ? [params] : [])] as const;
};

export const getNotificationsControllerGetNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: NotificationsControllerGetNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getNotificationsControllerGetNotificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsControllerGetNotifications>>
  > = ({ signal }) => notificationsControllerGetNotifications(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsControllerGetNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerGetNotifications>>
>;
export type NotificationsControllerGetNotificationsQueryError =
  ErrorType<unknown>;

export function useNotificationsControllerGetNotifications<
  TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | NotificationsControllerGetNotificationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetNotifications>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNotificationsControllerGetNotifications<
  TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: NotificationsControllerGetNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetNotifications>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNotificationsControllerGetNotifications<
  TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: NotificationsControllerGetNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 알람 목록 조회
 */

export function useNotificationsControllerGetNotifications<
  TData = Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: NotificationsControllerGetNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetNotifications>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getNotificationsControllerGetNotificationsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 읽지 않은 알람 개수 조회
 */
export const notificationsControllerGetUnreadCount = (signal?: AbortSignal) => {
  return api<NotificationsControllerGetUnreadCount200>({
    url: `/notifications/unread-count`,
    method: "GET",
    signal,
  });
};

export const getNotificationsControllerGetUnreadCountQueryKey = () => {
  return [`/notifications/unread-count`] as const;
};

export const getNotificationsControllerGetUnreadCountQueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getNotificationsControllerGetUnreadCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>
  > = ({ signal }) => notificationsControllerGetUnreadCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsControllerGetUnreadCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>
>;
export type NotificationsControllerGetUnreadCountQueryError =
  ErrorType<unknown>;

export function useNotificationsControllerGetUnreadCount<
  TData = Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNotificationsControllerGetUnreadCount<
  TData = Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNotificationsControllerGetUnreadCount<
  TData = Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 읽지 않은 알람 개수 조회
 */

export function useNotificationsControllerGetUnreadCount<
  TData = Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetUnreadCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getNotificationsControllerGetUnreadCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 전체 알람 읽음 처리
 */
export const notificationsControllerMarkAllAsRead = (
  markAllNotificationsReadBodyDto?: BodyType<MarkAllNotificationsReadBodyDto>,
) => {
  return api<NotificationsControllerMarkAllAsRead200>({
    url: `/notifications/read-all`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: markAllNotificationsReadBodyDto,
  });
};

export const getNotificationsControllerMarkAllAsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsControllerMarkAllAsRead>>,
    TError,
    { data: BodyType<MarkAllNotificationsReadBodyDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsControllerMarkAllAsRead>>,
  TError,
  { data: BodyType<MarkAllNotificationsReadBodyDto> },
  TContext
> => {
  const mutationKey = ["notificationsControllerMarkAllAsRead"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsControllerMarkAllAsRead>>,
    { data: BodyType<MarkAllNotificationsReadBodyDto> }
  > = (props) => {
    const { data } = props ?? {};

    return notificationsControllerMarkAllAsRead(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsControllerMarkAllAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerMarkAllAsRead>>
>;
export type NotificationsControllerMarkAllAsReadMutationBody =
  BodyType<MarkAllNotificationsReadBodyDto>;
export type NotificationsControllerMarkAllAsReadMutationError =
  ErrorType<unknown>;

/**
 * @summary 전체 알람 읽음 처리
 */
export const useNotificationsControllerMarkAllAsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof notificationsControllerMarkAllAsRead>>,
      TError,
      { data: BodyType<MarkAllNotificationsReadBodyDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof notificationsControllerMarkAllAsRead>>,
  TError,
  { data: BodyType<MarkAllNotificationsReadBodyDto> },
  TContext
> => {
  const mutationOptions =
    getNotificationsControllerMarkAllAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알람 읽음 처리
 */
export const notificationsControllerMarkAsRead = (id: string) => {
  return api<NotificationsControllerMarkAsRead200>({
    url: `/notifications/${id}/read`,
    method: "PATCH",
  });
};

export const getNotificationsControllerMarkAsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsControllerMarkAsRead>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsControllerMarkAsRead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["notificationsControllerMarkAsRead"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsControllerMarkAsRead>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return notificationsControllerMarkAsRead(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsControllerMarkAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerMarkAsRead>>
>;

export type NotificationsControllerMarkAsReadMutationError = ErrorType<unknown>;

/**
 * @summary 알람 읽음 처리
 */
export const useNotificationsControllerMarkAsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof notificationsControllerMarkAsRead>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof notificationsControllerMarkAsRead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getNotificationsControllerMarkAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알림 구독 정보 조회
 */
export const notificationsControllerGetSubscriptionInfo = (
  signal?: AbortSignal,
) => {
  return api<NotificationsControllerGetSubscriptionInfo200>({
    url: `/notifications/subscription-info`,
    method: "GET",
    signal,
  });
};

export const getNotificationsControllerGetSubscriptionInfoQueryKey = () => {
  return [`/notifications/subscription-info`] as const;
};

export const getNotificationsControllerGetSubscriptionInfoQueryOptions = <
  TData = Awaited<
    ReturnType<typeof notificationsControllerGetSubscriptionInfo>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getNotificationsControllerGetSubscriptionInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>
  > = ({ signal }) => notificationsControllerGetSubscriptionInfo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsControllerGetSubscriptionInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>
>;
export type NotificationsControllerGetSubscriptionInfoQueryError =
  ErrorType<unknown>;

export function useNotificationsControllerGetSubscriptionInfo<
  TData = Awaited<
    ReturnType<typeof notificationsControllerGetSubscriptionInfo>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof notificationsControllerGetSubscriptionInfo>
          >,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNotificationsControllerGetSubscriptionInfo<
  TData = Awaited<
    ReturnType<typeof notificationsControllerGetSubscriptionInfo>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof notificationsControllerGetSubscriptionInfo>
          >,
          TError,
          Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useNotificationsControllerGetSubscriptionInfo<
  TData = Awaited<
    ReturnType<typeof notificationsControllerGetSubscriptionInfo>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 알림 구독 정보 조회
 */

export function useNotificationsControllerGetSubscriptionInfo<
  TData = Awaited<
    ReturnType<typeof notificationsControllerGetSubscriptionInfo>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof notificationsControllerGetSubscriptionInfo>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getNotificationsControllerGetSubscriptionInfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Subscribe to push notifications
 */
export const pushNotificationControllerSubscribe = (
  pushSubscriptionDto: BodyType<PushSubscriptionDto>,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/notifications/push/subscribe`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: pushSubscriptionDto,
    signal,
  });
};

export const getPushNotificationControllerSubscribeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pushNotificationControllerSubscribe>>,
    TError,
    { data: BodyType<PushSubscriptionDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pushNotificationControllerSubscribe>>,
  TError,
  { data: BodyType<PushSubscriptionDto> },
  TContext
> => {
  const mutationKey = ["pushNotificationControllerSubscribe"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pushNotificationControllerSubscribe>>,
    { data: BodyType<PushSubscriptionDto> }
  > = (props) => {
    const { data } = props ?? {};

    return pushNotificationControllerSubscribe(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PushNotificationControllerSubscribeMutationResult = NonNullable<
  Awaited<ReturnType<typeof pushNotificationControllerSubscribe>>
>;
export type PushNotificationControllerSubscribeMutationBody =
  BodyType<PushSubscriptionDto>;
export type PushNotificationControllerSubscribeMutationError =
  ErrorType<unknown>;

/**
 * @summary Subscribe to push notifications
 */
export const usePushNotificationControllerSubscribe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pushNotificationControllerSubscribe>>,
      TError,
      { data: BodyType<PushSubscriptionDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof pushNotificationControllerSubscribe>>,
  TError,
  { data: BodyType<PushSubscriptionDto> },
  TContext
> => {
  const mutationOptions =
    getPushNotificationControllerSubscribeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Unsubscribe from push notifications
 */
export const pushNotificationControllerUnsubscribe = (
  pushUnsubscribeDto: BodyType<PushUnsubscribeDto>,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/notifications/push/unsubscribe`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: pushUnsubscribeDto,
    signal,
  });
};

export const getPushNotificationControllerUnsubscribeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pushNotificationControllerUnsubscribe>>,
    TError,
    { data: BodyType<PushUnsubscribeDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pushNotificationControllerUnsubscribe>>,
  TError,
  { data: BodyType<PushUnsubscribeDto> },
  TContext
> => {
  const mutationKey = ["pushNotificationControllerUnsubscribe"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pushNotificationControllerUnsubscribe>>,
    { data: BodyType<PushUnsubscribeDto> }
  > = (props) => {
    const { data } = props ?? {};

    return pushNotificationControllerUnsubscribe(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PushNotificationControllerUnsubscribeMutationResult = NonNullable<
  Awaited<ReturnType<typeof pushNotificationControllerUnsubscribe>>
>;
export type PushNotificationControllerUnsubscribeMutationBody =
  BodyType<PushUnsubscribeDto>;
export type PushNotificationControllerUnsubscribeMutationError =
  ErrorType<unknown>;

/**
 * @summary Unsubscribe from push notifications
 */
export const usePushNotificationControllerUnsubscribe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof pushNotificationControllerUnsubscribe>>,
      TError,
      { data: BodyType<PushUnsubscribeDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof pushNotificationControllerUnsubscribe>>,
  TError,
  { data: BodyType<PushUnsubscribeDto> },
  TContext
> => {
  const mutationOptions =
    getPushNotificationControllerUnsubscribeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
